<template>
    <!-- AgentsContainer.vue -->
    <base-container
        :items="itemsFormatted"
        :loading="loading"
        :title="title"
        class="agents-container"
        suffix-text-color="secondary"
        title-color="secondary"
    >
        <!-- Agent Tiles -->
        <template v-slot:item="{item, tileHeight}">
            <v-col
                :id="item.uuid"
                :key="item.uuid"
                cols="12"
            >
                <!-- Agent Card -->
                <agent-card :height="tileHeight" :item="item"></agent-card>
            </v-col>
        </template>
        <template v-slot:no-data>
            <v-col cols="12">
                <v-alert color="crisis" prominent type="error">
                    <div class="text-h4">No Users Active!</div>
                </v-alert>
            </v-col>
        </template>
    </base-container>
</template>

<script>
    import {map} from 'underscore'
    import dateUtils from '@windsor-telecom/client-core/src/utils/date'
    import AgentCard from '@/components/AgentCard'
    import BaseContainer from '@/components/BaseContainer'

    export default {
        name: 'AgentsContainer',
        data: () => ({
            itemsFormatted: [],
            timeoutId: false
        }),
        props: {
            /**
             * An array of items to display i.e. [{color, title, value}]
             */
            items: {
                type: Array,
                required: true
            },
            /**
             * Toggle the skeleton loader
             */
            loading: {
                type: Boolean,
                default: false
            },
            /**
             * The title of the agents section
             */
            title: {
                type: String,
                default: 'Users'
            }
        },
        components: {
            AgentCard,
            BaseContainer
        },
        methods: {
            startTimeUpdater () {
                const vm = this

                if (vm.timeoutId) {
                    clearTimeout(vm.timeoutId)
                }

                vm.itemsFormatted = map(vm.items, agent => {
                    return {
                        ...agent,
                        status: {
                            ...agent.status,
                            startTime: dateUtils.fromNowDuration(agent.status.startTime)
                        }
                    }
                })

                vm.timeoutId = setTimeout(vm.startTimeUpdater, 1000)
            }
        },
        watch: {
            items () {
                this.startTimeUpdater()
            }
        },
        created () {
            this.startTimeUpdater()
        }
    }
</script>
